// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"101":"6c459431","331":"fef7cd96","638":"592136bf","892":"db693d45"}[chunkId] + ".css";
};